import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlaylistsHttpResult } from '../../models/playlist.model';
import { PlaylistApi } from '../playlist.api';

@Injectable({
  providedIn: 'root',
  useClass: PlaylistApi
})
export abstract class IPlaylistApi {
  abstract getPlaylists(page: number, limit: number, userId?: number): Observable<PlaylistsHttpResult>;
}
